var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { StyledRow } from './styles';
import { ChevronArrow } from '../ChevronArrow';
var defaultRenderer = function (item, field) {
  if (typeof item[field] === 'undefined') {
    throw new Error("Data not found for ".concat(field));
  }
  return item[field];
};
export var TableRow = function (props) {
  var _a = useState(false),
    isOpen = _a[0],
    toggleDetail = _a[1];
  var item = props.item,
    rowIndex = props.rowIndex,
    headers = props.headers,
    _b = props.options,
    _c = _b === void 0 ? {} : _b,
    isHighlight = _c.isHighlight,
    ExpandableComponent = _c.ExpandableComponent,
    isExpandableRow = _c.isExpandableRow,
    onRowActionClick = _c.onRowActionClick,
    onRowClick = _c.onRowClick,
    isClickableRowAction = _c.isClickableRowAction,
    isClickableRow = _c.isClickableRow,
    showArrows = props.showArrows,
    showStickyCols = props.showStickyCols,
    customProps = __rest(props, ["item", "rowIndex", "headers", "options", "showArrows", "showStickyCols"]);
  var isExpandable = function () {
    return ExpandableComponent && (!isExpandableRow || isExpandableRow(item));
  };
  var isClickableAction = function () {
    return !isClickableRowAction || isClickableRowAction(item);
  };
  var isRowClickable = isClickableRow && isClickableRow(item) && onRowClick;
  var getHeaders = function () {
    if (showArrows) {
      if (isExpandable()) {
        return __spreadArray(__spreadArray([], headers, true), [{
          title: ' ',
          render: function () {
            return _jsx(ChevronArrow, {
              isOpen: isOpen
            });
          }
        }], false);
      }
      if (onRowActionClick && isClickableAction()) {
        return __spreadArray(__spreadArray([], headers, true), [{
          title: ' ',
          render: function (row) {
            return _jsx(ChevronArrow, {
              style: {
                cursor: 'pointer'
              },
              isOpen: isOpen,
              pointRight: true,
              onClick: function () {
                return onRowActionClick(row);
              }
            });
          }
        }], false);
      }
    }
    return headers;
  };
  var renderCells = function () {
    var stickyCounter = 0;
    return getHeaders().map(function (_a, cellIndex) {
      var field = _a.field,
        render = _a.render,
        minWidth = _a.minWidth,
        isSticky = _a.isSticky;
      var renderTemplate = render ? render : defaultRenderer;
      var style = {};
      if (showStickyCols && isSticky) {
        style.minWidth = String(minWidth || '150px');
        style.position = 'sticky';
        var getWidth = Number(style.minWidth.replace(/\D/g, ''));
        style.left = stickyCounter;
        stickyCounter += getWidth;
      }
      return _jsx("td", {
        style: style,
        children: renderTemplate(item, field)
      }, "cell-".concat(rowIndex, "-").concat(cellIndex));
    });
  };
  var handleRowClick = function () {
    if (isExpandable()) toggleDetail(!isOpen);
    if (isRowClickable) onRowClick(item);
    return false;
  };
  var AddExpandableRow = function () {
    return _jsx(StyledRow, {
      children: _jsx("td", {
        colSpan: getHeaders().length,
        children: ExpandableComponent ? _jsx(ExpandableComponent, {
          item: item
        }) : null
      })
    });
  };
  return _jsxs(_Fragment, {
    children: [_jsx(StyledRow, __assign({
      highlighted: isHighlight && isHighlight(item, rowIndex),
      onClick: handleRowClick,
      clickable: isExpandable() || !!isRowClickable,
      hoverable: !!isRowClickable
    }, customProps, {
      children: renderCells()
    })), isOpen && AddExpandableRow()]
  });
};